import React, { Component, Fragment } from "react";
import { isEmpty, size } from "lodash";



import Basic from "../../../container/layouts/Basic";
import UserSpendingForm from "../../UserView/UserSpendings/UserSpendingForm";
import SpendingExtractButton from "./SpendingExtractButton";

import Notif from "../../common/Notif";

import {
  Edit,
  Delete,
  FilterListRounded,
  CloseRounded,
  AddCircle,
  DeleteRounded,
  EditRounded,
} from "@mui/icons-material";
import {
  Grid,
  Typography,
  TableContainer,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  TableFooter,
  TablePagination,
  IconButton,
  Button,
  Paper,
  Tabs,
  Tab,
} from "@mui/material";

import Pagination from "../../../container/MUI/Pagination";
import SpendingDetails from "../../Spendings/SpendingDetails";
import FilterSpendings from "../../Spendings/FilterSpendings";
import DeleteDialog, { DeleteDialogNoPwd } from "../../common/DeleteDialog";
import Currency from "../../common/Currency";
import { matchesDesc, parseAmount, inRange } from "../../../utils/searchFilters";
import { URL_APP_V2 } from "../../Admin/AdminDashboard";
import IframeV1 from "../../Admin/IFrame/Iframe";

const STATUS = {
  WAITING_UPDATE: "À Corriger",
  WAITING_VALIDATION: "En Attente de Validation",
  VALIDATE: "Validé",
  REFUSED: "Refusé",
};

class UserSpendingsList extends Component {
  state = {
    page: 0,
    rowsPerPage: 15,
    newSpending: false,
    validateSpending: false,
    updateSpending: false,
    openDetails: false,
    selectedSpending: {},
    filteredList: Object.values(this.props.SPENDINGS),
    spending: {},
    searchLabel: "",
    searchCategory: { value: "", label: "" },
    spend_status: "",
    searchSubCategory: "",
    searchSupplier: "",
    searchMonth: "",
    searchYear: "",
    searchDesc: "",
    amountMin: "",
    amountMax: "",
    tab: 1,
    refreshKey: 0,
    spendingDemandId: typeof window !== "undefined" ? (new URLSearchParams(window.location.search).get("spending_demand_id") || "") : "",
    spendingDemandName: "",
    spendingDemandAmount: "",
    spendingDemandAmountTTC: "",
    spendingDemandDesc: "",

    notif: {
      openNotif: "",
      variant: "",
      message: "",
    },
    openFilters: false,
  };

  componentDidMount = () => {
    // Écouter les changements de token pour rafraîchir les iframes
    this.setupTokenChangeListener();
    
    // Vérifier si le paramètre ?new=true est présent dans l'URL
    const params = new URLSearchParams(window.location.search);
    const newParam = params.get('new');
    const spendingDemandId = params.get('spending_demand_id');
    const spendingDemandNameParam = params.get('spending_demand_name');
    const spendingDemandName = spendingDemandNameParam || "";
    const spendingDemandAmount = params.get('spending_demand_amount') || "";
    const spendingDemandAmountTTC = params.get('spending_demand_amountTTC') || "";
    const spendingDemandDescParam = params.get('spending_demand_desc');
    const spendingDemandDesc = spendingDemandDescParam || "";
    
    console.log('================== UserSpendingsList componentDidMount ===================');
    console.log('newParam:', newParam);
    console.log('spendingDemandId:', spendingDemandId);
    console.log('spendingDemandName:', spendingDemandName);
    console.log('spendingDemandAmount:', spendingDemandAmount);
    console.log('spendingDemandAmountTTC:', spendingDemandAmountTTC);
    console.log('spendingDemandDesc:', spendingDemandDesc);
    console.log('====================================');
    
    if (newParam === 'true') {
      this.setState({ 
        newSpending: true,
        spendingDemandId: spendingDemandId || "",
        spendingDemandName: spendingDemandName,
        spendingDemandAmount: spendingDemandAmount,
        spendingDemandAmountTTC: spendingDemandAmountTTC,
        spendingDemandDesc: spendingDemandDesc
      });
      // Nettoyer l'URL pour retirer le paramètre après ouverture de la modale
      const newUrl = window.location.pathname;
      window.history.replaceState({}, '', newUrl);
    } else if (spendingDemandId) {
      // spendingDemandId est déjà dans l'état initial pour que l'iframe
      // charge directement /spending_demand_user/{id}. On nettoie juste l'URL.
      window.history.replaceState({}, '', window.location.pathname);
    }
  }

  componentWillUnmount() {
    // Nettoyer l'écouteur d'événements
    this.removeTokenChangeListener();
  }

  // Méthode pour écouter les changements de token
  setupTokenChangeListener = () => {
    window.addEventListener('tokenChanged', this.handleTokenChange);
  }

  // Méthode pour supprimer l'écouteur d'événements
  removeTokenChangeListener = () => {
    window.removeEventListener('tokenChanged', this.handleTokenChange);
  }

  // Gérer les changements de token
  handleTokenChange = (e) => {
    console.log('UserSpendingsList: Token changé, rafraîchissement des iframes');
    // Forcer le rafraîchissement de toutes les iframes
    this.refreshIframe();
  }

  refreshIframe = () => {
    this.setState(prevState => ({ refreshKey: prevState.refreshKey + 1 }));
  };

  handleChangePage = (event, page) => {
    this.setState({ page });
  };

  handleChangeRowsPerPage = (event) => {
    this.setState({ page: 0, rowsPerPage: parseInt(event.target.value) });
  };

  filterCat = (list) => {
    const { CATEGORIES } = this.props;
    const { searchCategory } = this.state;
    let newList = [];
    console.log("====================================");
    console.log({ searchCategory });
    console.log("====================================");
    list.forEach((item) => {
      if (!searchCategory.value) {
        newList.push(item);
      } else if (
        CATEGORIES.ALL[searchCategory.value].includes(item.spending_category)
      ) {
        newList.push(item);
      }
    });

    return newList;
  };
  filterSubCat = (list) => {
    const { ALL, LIST } = this.props.CATEGORIES;
    const { searchSubCategory } = this.state;
    let newList = [];

    list.forEach((item) => {
      if (!searchSubCategory) {
        newList.push(item);
      } else if (item.spending_category === searchSubCategory) {
        newList.push(item);
      } else if (
        LIST[searchSubCategory] &&
        LIST[searchSubCategory].includes(item.spending_category)
      ) {
        newList.push(item);
      }
    });
    return newList;
  };

  filterStatus = (list) => {
    const { spend_status } = this.state;

    if (spend_status !== "") {
      list = list.filter((item) => item.spending_status === spend_status);
    }

    return list;
  };

  filterList = () => {
    const { SPENDINGS } = this.props;
    const { searchMonth, searchYear, searchDesc, amountMin, amountMax } = this.state;

    let list = Object.values(SPENDINGS);
    list = this.filterStatus(list);
    // cat
    list = this.filterCat(list);
    // subCat
    list = this.filterSubCat(list);
    if (!isEmpty(searchMonth.value)) {
      list = list.filter(
        (item) => new Date(item.spending_date).getMonth() == searchMonth
      );
    } else if (Array.isArray(searchMonth) && !isEmpty(searchMonth)) {
      let itemList = searchMonth.map((item) => item.value);
      list = list.filter((item) =>
        itemList.includes(new Date(item.spending_date).getMonth())
      );
    }

    if (searchYear) {
      list = list.filter(
        (item) => new Date(item.spending_date).getFullYear() == searchYear
      );
    }
    if (Array.isArray(searchYear)) {
      let itemList = searchYear.map((item) => item.value);
      list = list.filter((item) =>
        itemList.includes(new Date(item.spending_date).getFullYear())
      );
    }

    const min = parseAmount(amountMin);
    const max = parseAmount(amountMax);
    if (searchDesc && searchDesc.trim() !== "") {
      list = list.filter((item) => matchesDesc(item.spending_desc, searchDesc));
    }
    if (min !== null || max !== null) {
      list = list.filter((item) => inRange(item.spending_amountTTC, min, max));
    }

    return list;
  };

  getSpendingList = (list, bckg) => {
    const { rowsPerPage, page } = this.state;
    const { CATEGORIES, USERS } = this.props;

    return list
      .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
      .map((item) => {
        let category = CATEGORIES.CHILD[item.spending_category];
        if (item.spending_status === "WAITING_VALIDATION") {
          bckg = "cornsilk";
        }
        if (item.spending_status === "WAITING_UPDATE") {
          bckg = "#f7d0d6";
        }
        return (
          <TableRow
            hover
            key={item.id}
            className="clickable"
            style={{ backgroundColor: bckg }}
          >
            <TableCell
              onClick={() =>
                this.setState({ openDetails: true, selectedSpending: item })
              }
            >
              {new Date(item.spending_date).toLocaleDateString("fr-FR")}
            </TableCell>
            <TableCell
              onClick={() =>
                this.setState({ openDetails: true, selectedSpending: item })
              }
            >
              {STATUS[item.spending_status]}
            </TableCell>
            <TableCell
              onClick={() =>
                this.setState({ openDetails: true, selectedSpending: item })
              }
            >
              {category && category.category_name}
            </TableCell>
            <TableCell
              onClick={() =>
                this.setState({ openDetails: true, selectedSpending: item })
              }
            >
              {item.spending_desc}
            </TableCell>

            <TableCell
              onClick={() =>
                this.setState({ openDetails: true, selectedSpending: item })
              }
            >
              {item.spending_amountTTC}
            </TableCell>
            <TableCell>
              {(item.spending_status === "WAITING_VALIDATION" ||
                item.spending_status === "WAITING_UPDATE") && (
                <IconButton
                  color="primary"
                  onClick={() => this.handleOpenUpdate(item)}
                  size="large"
                >
                  <EditRounded />
                </IconButton>
              )}
            </TableCell>
            <TableCell>
              {item.spending_status === "WAITING_VALIDATION" && (
                <IconButton
                  color="primary"
                  onClick={() => this.handleOpenDelete(item)}
                  size="large"
                >
                  <DeleteRounded />
                </IconButton>
              )}
            </TableCell>
          </TableRow>
        );
      });
  };

  // displayList = () => {
  //     const { SPENDINGS } = this.props;
  //     let tab = []
  //     if (!isEmpty(SPENDINGS)){
  //         let filteredList = this.filterList()
  //         let filterWaiting = filteredList.filter(item => (item.spending_status === "WAITING_VALIDATION"))
  //         let filterUpdate = filteredList.filter(item => (item.spending_status === "WAITING_UPDATE"))
  //         let filterValidate = filteredList.filter(item => (item.spending_status === "VALIDATE"))

  //         tab.push(this.getSpendingList(filterUpdate, "#f7d0d6"), this.getSpendingList(filterWaiting, "cornsilk"), this.getSpendingList(filterValidate))
  //     }
  //     return tab
  // }
  displayList = () => {
    const { SPENDINGS } = this.props;

    let tab = [];
    let rows = 0;
    if (!isEmpty(SPENDINGS)) {
      let filteredList = this.filterList();
      let filterWaiting = filteredList.filter(
        (item) => item.spending_status === "WAITING_VALIDATION"
      );
      let filterUpdate = filteredList.filter(
        (item) => item.spending_status === "WAITING_UPDATE"
      );
      let filterValidate = filteredList.filter(
        (item) => item.spending_status === "VALIDATE"
      );

      let all = [].concat(filterUpdate, filterWaiting, filterValidate);
      rows = size(all);
      tab.push(this.getSpendingList(all));
      // tab.push(this.getSpendingList(filterWaiting, "cornsilk"), this.getSpendingList(filterUpdate, "#f7d0d6"), this.getSpendingList(filterValidate))
    }
    return [tab, rows];
  };
  handleOpen = () => {
    this.setState({
      newSpending: true,
    });
  };

  handleOpenUpdate = (spending) => {
    this.setState({
      spending,
      updateSpending: true,
    });
  };
  handleOpenDelete = (spending) => {
    this.setState({
      spending,
      deleteSpending: true,
    });
  };
  handleDelete = async () => {
    const { spending } = this.state;
    await this.props.deleteSpending(spending);
    if (this.props.STATE.spendings.error) {
      this.notif(true, "error", this.props.STATE.spendings.error);
    } else {
      this.notif(true, "success", "Dépense supprimée");
      this.setState({
        deleteSpending: false,
        spending: {},
      });
    }
  };
  handleClose = () => {
    this.setState({
      newSpending: false,
      updateSpending: false,
      deleteSpending: false,
      spending: {},
      spendingDemandId: "",
      spendingDemandName: "",
      spendingDemandAmount: "",
      spendingDemandAmountTTC: "",
      spendingDemandDesc: "",
    });
  };
  handleChange = (e) => {
    const { name, value } = e.target;
    if (name === "searchCategory") {
      this.setState({
        searchSubCategory: "",
        searchSubCategory2: "",
        [name]: value,
        page: 0,
      });
    } else if (name === "searchSubCategory") {
      this.setState({
        searchSubCategory2: "",
        [name]: value,
        page: 0,
      });
    } else {
      this.setState({
        [name]: value,
        page: 0,
      });
    }
  };
  handleChangeMulti = (option, field) => {
    console.log("====================================");
    console.log({ option, field });
    console.log("====================================");
    if (field === "searchCategory" && !isEmpty(option.value)) {
      this.setState({
        searchSubCategory: "",
        searchSubCategory2: "",
        [field]: option,
        page: 0,
      });
    } else if (option) {
      this.setState({
        [field]: option,
        page: 0,
        // checkedItems :[]
      });
    } else {
      this.setState({
        [field]: { label: "", value: "" },
        page: 0,
        // checkedItems :[]
      });
    }
  };
  handleSelect = (option, field) => {
    if (option) {
      this.setState({
        [field]: option,
        page: 0,
      });
    } else {
      this.setState({
        searchEmployee: { label: "", value: "" },
        page: 0,
      });
    }
  };
  notif = (openNotif, variant, message) => {
    this.setState({
      notif: {
        openNotif,
        variant,
        message,
      },
    });
  };

  render() {
    const {
      page,
      rowsPerPage,
      newSpending,
      validateSpending,
      updateSpending,
      spending,
      openDetails,
      selectedSpending,
      openFilters,
      deleteSpending,
    } = this.state;
    const { openNotif, variant, message } = this.state.notif;

    const { SPENDINGS, CATEGORIES, SUPPLIERS } = this.props;
    const spendingsList = this.displayList();

    return (
      <>
        <Basic spendings {...this.props}>
          {openNotif && variant && message && (
            <Notif
              open={openNotif}
              onClose={() => this.notif(false)}
              variant={variant}
              message={message}
            />
          )}
          {openDetails && selectedSpending && (
            <SpendingDetails
              supplier={
                SUPPLIERS && SUPPLIERS[selectedSpending.spending_supplier]
              }
              category={
                CATEGORIES.CHILD &&
                CATEGORIES.CHILD[selectedSpending.spending_category]
              }
              spending={selectedSpending}
              view={"USER"}
              handleClose={() =>
                this.setState({ openDetails: false, selectedSpending: {} })
              }
            />
          )}
          {newSpending && (
            <UserSpendingForm
              handleClose={this.handleClose}
              notif={this.notif}
              spending_demand_id={this.state.spendingDemandId}
              spending_demand_name={this.state.spendingDemandName}
              spending_demand_amount={this.state.spendingDemandAmount}
              spending_demand_amountTTC={this.state.spendingDemandAmountTTC}
              spending_demand_desc={this.state.spendingDemandDesc}
              {...this.props}
            />
          )}
          {updateSpending && spending && (
            <UserSpendingForm
              update
              handleClose={this.handleClose}
              spending={spending}
              notif={this.notif}
              {...this.props}
            />
          )}
          {deleteSpending && !isEmpty(spending) && (
            <DeleteDialogNoPwd
              title={"la dépense"}
              close={() =>
                this.setState({ deleteSpending: false, spending: {} })
              }
              notif={this.notif}
              handleSubmit={this.handleDelete}
            >
              Dépense du{" "}
              {new Date(spending.spending_date).toLocaleDateString("fr-FR")} -
              Montant: <Currency value={spending.spending_amountTTC} />
            </DeleteDialogNoPwd>
          )}

          {/* <Paper> */}
          <Tabs
            value={this.state.tab}
            onChange={(e, tab) => this.setState({ tab })}
            indicatorColor="primary"
            textColor="primary"
            variant="fullWidth"
            scrollButtons="auto"
            // variant="scrollable"
          >
            <Tab label="Dépenses" />
            <Tab label="Demandes de dépenses" />
          </Tabs>
          {this.state.tab === 0 && (<>
                    <Typography variant="h6" id="tableTitle">
            Mes Dépenses
          </Typography>

          <Grid container spacing={2} alignItems="center">
            <Grid item sm={4} xs={12}>
              <Button
                // variant="contained"
                onClick={() =>
                  this.setState({ openFilters: !this.state.openFilters })
                }
              >
                <FilterListRounded /> Filtres
              </Button>
            </Grid>
            <Grid item sm={4} xs={12}>
              <SpendingExtractButton
                filters={{
                  searchMonth: this.state.searchMonth,
                  searchYear: this.state.searchYear,
                  searchCategory: this.state.searchCategory,
                  searchSubCategory: this.state.searchSubCategory,
                  searchSupplier: this.state.searchSupplier,
                  spend_status: this.state.spend_status,
                }}
              />
            </Grid>
            <Grid item sm={4} xs={12} style={{ textAlign: "right" }}>
              <Button
                variant="contained"
                color="secondary"
                onClick={this.handleOpen}
                title="Nouvelle Dépense"
              >
                <AddCircle />
                Ajouter
              </Button>
            </Grid>
          </Grid>

          {openFilters && (
            <FilterSpendings
              CATEGORIES={CATEGORIES}
              handleClose={() => this.setState({ openFilters: false })}
              handleChange={this.handleChange}
              handleChangeMulti={this.handleChangeMulti}
              handleSelect={this.handleSelect}
              {...this.state}
              withSearchFilters
            />
          )}

          <TableContainer>
            <Table>
              <TableHead>
                <TableRow>
                  <TableCell>Créé le</TableCell>

                  <TableCell>Statut</TableCell>
                  <TableCell>Catégorie</TableCell>
                  <TableCell>Description</TableCell>
                  <TableCell>Montant</TableCell>
                  <TableCell>Modifier</TableCell>
                  <TableCell>Supprimer</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>{spendingsList[0]}</TableBody>
              {spendingsList[1] > 10 && (
                <TableFooter>
                  <TableRow>
                    <TablePagination
                      rowsPerPageOptions={[10, 15]}
                      labelRowsPerPage="Lignes par Page"
                      colSpan={8}
                      count={spendingsList[1]}
                      rowsPerPage={rowsPerPage}
                      page={page}
                      SelectProps={{
                        native: true,
                      }}
                      onPageChange={this.handleChangePage}
                      onRowsPerPageChange={this.handleChangeRowsPerPage}
                      ActionsComponent={Pagination}
                    />
                  </TableRow>
                </TableFooter>
              )}
            </Table>
          </TableContainer>
          </>)}
          {this.state.tab === 1 && (<>

            <IframeV1
              url={
                "/spending_demand_user"+(
                  this.state.spendingDemandId ? "/"+this.state.spendingDemandId : ""
                )
              }
              token={localStorage.jwtToken_compta}
              key={this.state.refreshKey}
              hasSidebar={false}
              topOffset={48}
              title="spen-demand"
           
          />

            
          </>)}
          {/* </Paper> */}
        </Basic>
      </>
    );
  }
}

export default UserSpendingsList;
